import { defineRule } from 'vee-validate'

const password = () => {
  defineRule<string, any[]>('password', (value, _target, _ctx: any) => {
    return testPassword(value)
  })
}

export default password
